export default {
	text: "Browse topics",
};
